import ActionButton from 'lib/src/components/button/ActionButton';
import ButtonRow from 'lib/src/components/button/ButtonRow';
import Modal from '@components/modal/Modal';
import React from 'react';
import useCopyToClipboard from 'lib/src/hooks/useCopyToClipboard';

const LinkModal: React.FC<LinkModalProps> = ({ token, closeModal }) => {
    const { copyToClipboard, copySuccess, copyFailure } = useCopyToClipboard();
    return (
        <Modal title="Share link" size="small" closeModal={closeModal}>
            {!!token && (
                <>
                    <a
                        href={`${window.location.protocol}//www.${window.location.hostname.replace(
                            'admin.',
                            '',
                        )}/expiring/score-summary/?token=${token}`}
                        target="_blank"
                        rel="noreferrer"
                        className="link-to-copy"
                    >{`${window.location.protocol}//www.${window.location.hostname.replace(
                        'admin.',
                        '',
                    )}/expiring/score-summary/?token=${token}`}</a>
                </>
            )}
            {copySuccess && <p className="form-generic-success">Copied link to clipboard</p>}
            {copyFailure && <p className="form-generic-error">Couldn't copy link to clipboard</p>}
            {!token && (
                <p className="form-generic-error">
                    Couldn't create a link at this time. Please try again later.
                </p>
            )}
            <ButtonRow alignment="left">
                {!!token && (
                    <ActionButton
                        color="green"
                        onClick={() =>
                            copyToClipboard(
                                `${
                                    window.location.protocol
                                }//www.${window.location.hostname.replace(
                                    'admin.',
                                    '',
                                )}/expiring/score-summary/?token=${token}`,
                            )
                        }
                    >
                        Copy link
                    </ActionButton>
                )}

                <ActionButton color="grey" onClick={closeModal}>
                    Cancel
                </ActionButton>
            </ButtonRow>
        </Modal>
    );
};

interface LinkModalProps {
    token: string | null;
    closeModal: () => void;
}

export default LinkModal;
